import React from "react"
import { cn } from "@/lib/utils"

interface OptimGovLoaderProps {
	size?: "sm" | "md" | "lg"
	className?: string
	fullScreen?: boolean
}

/**
 * Animated OptimGov logo loader using the brand fingerprint icon.
 * Uses the actual logo PNG with a pulse animation for perfect brand fidelity.
 */
export const OptimGovLoader: React.FC<OptimGovLoaderProps> = ({ size = "md", className, fullScreen = false }) => {
	const sizeMap = {
		sm: { container: "w-10 h-10", px: 40 },
		md: { container: "w-14 h-14", px: 56 },
		lg: { container: "w-20 h-20", px: 80 },
	}

	const { container, px } = sizeMap[size]

	const loader = (
		<div className={cn(container, "optimgov-loader", className)}>
			<img
				src="/OptimLogo.png"
				alt=""
				width={px}
				height={px}
				className="w-full h-full object-contain"
			/>
		</div>
	)

	if (fullScreen) {
		return (
			<div className="fixed inset-0 z-50 flex items-center justify-center bg-white/80 backdrop-blur-sm">
				{loader}
			</div>
		)
	}

	return loader
}

/**
 * Full-page loader with OptimGov branding, used for route-level loading states.
 */
export const OptimGovPageLoader: React.FC = () => {
	return (
		<div className="flex items-center justify-center min-h-screen">
			<OptimGovLoader size="lg" />
		</div>
	)
}
